import { render } from "./FinalTestingAttemptPage.vue?vue&type=template&id=b831e998&scoped=true"
import script from "./FinalTestingAttemptPage.vue?vue&type=script&lang=js"
export * from "./FinalTestingAttemptPage.vue?vue&type=script&lang=js"

import "./FinalTestingAttemptPage.vue?vue&type=style&index=0&id=b831e998&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b831e998"]])

export default __exports__